import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import paymentDetailsAPI from '../../sources/api/paymentDetailsAPI';

// constants
import { CANCEL_SUBSCRIPTION } from '../../constants/paymentDetailsTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { paymentDetailsSchema } from '../../schemas/Normalizr';
import { tooltipHide } from '../../actions/tooltipActions';
import { toastr } from 'react-redux-toastr';
import { CANCEL_SUBSCRIPTION_ERROR, CANCEL_SUBSCRIPTION_SUCCESS } from '../../constants/messages';
import { CANCEL_SUBSCRIPTION_MODAL } from '../../constants/modals';

export function* renewSubscription(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(CANCEL_SUBSCRIPTION, call(paymentDetailsAPI.cancelSubscription, params), paymentDetailsSchema);
    yield put(tooltipHide({ id: CANCEL_SUBSCRIPTION_MODAL }));
    yield toastr.success('Success', CANCEL_SUBSCRIPTION_SUCCESS);
  } catch (e) {
    yield toastr.error(CANCEL_SUBSCRIPTION_ERROR);
    yield put(error(CANCEL_SUBSCRIPTION, e));
  } finally {
    yield put(doneIndicator(CANCEL_SUBSCRIPTION));
  }
}

export function* watchRenewSubscription() {
  yield takeEvery(CANCEL_SUBSCRIPTION, renewSubscription);
}

export default function* root() {
  yield all([
    fork(watchRenewSubscription)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/paymentDetails/cancelSubscription.js